import { format, parseISO } from 'date-fns';

export let formatDateForInput = (date) => {
  return date ? format(parseISO(date), 'MM/dd/yyyy') : null;
};

export let formatDateForYearInput = (date) => {
  return date ? parseInt(format(parseISO(date), 'yyyy'), 10) : null;
};
